export default __webpack_public_path__ + "static/media/greeting8.677136f6.svg";